import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {
  ApiService,
  ESearchBlockPath,
  ETireDecInc,
  IAllData,
  IApiRequestContactBody,
  IApiResponseAll,
  IApiResponseData,
  IBranchDetails,
  IBranchSearchOptions,
  INewsData,
  IProductData,
  IProductId,
  IProductSearchOptions,
  IPromotionData,
  ISearchBlockOptions,
  ITireDecIncRequire,
  IVideoData,
  IGalleryData,
  IOption,
  IApiRequestGalleryLikeBody,
} from './api.service';
import { catchError, map, Observable, tap, throwError } from 'rxjs';
import { IPaging } from '../models/promoWebInterface';
import { NG_APP_API_ENDPOINT } from '@web-nx-ng-tsc/shared-constant';
import { LoggingService } from '@web-nx-ng-tsc/util-logging';

// const BASE_URL = 'https://tsc-api-dev.connecit.net/api/front';
@Injectable({ providedIn: 'root' })
export class RestApiService extends ApiService {
  private readonly http = inject(HttpClient);
  private readonly loggingService = inject(LoggingService);

  // SECTION: GET

  // SECTION: PRODUCTS
  //#region
  // NOTE: GET AllProduct
  getAllProduct(): Observable<IAllData> {
    return this.http.get<IApiResponseAll>(`${NG_APP_API_ENDPOINT}/product/brands?visibility=grip`).pipe(
      tap((res: IApiResponseAll) => this.loggingService.warn('GET | getAllProduct[API] :', res)),
      map((res: IApiResponseAll) => res.data as IAllData),
      catchError((error) => {
        this.loggingService.error(error);
        return throwError(() => error);
      })
    );
  }

  getAllProductCategory(
    visibility: string,
    category: string,
    options: IProductSearchOptions = {},
    paging: IPaging = { cur: 1, per: 20 }
  ): Observable<IAllData> {
    let params = new HttpParams().set('visibility', visibility).set('category', category);

    // Add optional parameters dynamically
    Object.entries(options).forEach(([key, value]) => {
      if (value) {
        params = params.set(key, value);
      }
    });

    Object.entries(paging).forEach(([key, value]) => {
      if (value) {
        params = params.set(key, value);
      }
    });

    console.log('visibility', visibility, 'params', params);

    return this.http.get<IApiResponseAll>(`${NG_APP_API_ENDPOINT}/product/search`, { params }).pipe(
      tap((res) => this.loggingService.warn('GET | getAllProductCategory[API] :', res)),
      map((res: IApiResponseAll) => res.data as IAllData),
      catchError((error) => {
        this.loggingService.error(error);
        return throwError(() => error);
      })
    );
  }
  getProductTable(visibility: string, category: string, options: IProductSearchOptions = {}): Observable<IAllData> {
    let params = new HttpParams().set('visibility', visibility).set('category', category);
    // Add optional parameters dynamically
    Object.entries(options).forEach(([key, value]) => {
      if (value) {
        params = params.set(key, value);
      }
    });
    return this.http.get<IApiResponseAll>(`${NG_APP_API_ENDPOINT}/product/tire/table-specs`, { params }).pipe(
      tap((res) => this.loggingService.warn('GET | getAllProductCategory[API] :', res)),
      map((res: IApiResponseAll) => res.data as IAllData),
      catchError((error) => {
        this.loggingService.error(error);
        return throwError(() => error);
      })
    );
  }
  // NOTE: GET ProductById
  getProductById(visibility: string, id: number): Observable<IProductData> {
    return this.http
      .get<IApiResponseData>(`${NG_APP_API_ENDPOINT}/product/data?visibility=${visibility}&id=${id}`)
      .pipe(
        tap((res) => this.loggingService.warn('GET | getProductById[API] :', res)),
        map((res: IApiResponseData) => res.data as IProductData),
        catchError((error) => {
          this.loggingService.error(error);
          return throwError(() => error);
        })
      );
  }

  // NOTE: GET TireDecInc
  getTireDecInc(visibility: string, options: ETireDecInc, preq: ITireDecIncRequire): Observable<IProductId> {
    let params = new HttpParams().set('visibility', visibility).set('on', options);

    // Add preq parameters dynamically
    Object.entries(preq).forEach(([key, value]) => {
      if (value) {
        params = params.set(key, value);
      }
    });

    return this.http.get<IApiResponseData>(`${NG_APP_API_ENDPOINT}/product/tire/to`, { params }).pipe(
      tap((res) => this.loggingService.warn('GET | getTireDecInc[API] :', res)),
      map((res: IApiResponseData) => res.data as IProductId),
      catchError((error) => {
        this.loggingService.error(error);
        return throwError(() => error);
      })
    );
  }
  getTireSelectedUpDown(size: string, brand: number, model: string): Observable<IProductId> {
    const params = new HttpParams().set('size', size).set('brand', brand).set('model', model);
    this.loggingService.log('params', params);
    return this.http.get(`${NG_APP_API_ENDPOINT}/product/tire/id`, { params }).pipe(
      tap((res) => this.loggingService.log('TAP | getTireSelectedUpDown[ProductService] :', res)),
      map((res: any) => res.data),
      tap((res) => this.loggingService.log('TAP | getTireSelectedUpDown[ProductService] aftermap get data :', res)),
      catchError((error) => {
        this.loggingService.error('CATCH ERROR | getTireSelectedUpDown[ProductService] :', error);
        return throwError(() => error);
      })
    );
  }
  getChangeTire(preq: ITireDecIncRequire, onChange: string) {
    let params = new HttpParams().set('on', onChange).set('load_index', preq.loadindex);
    Object.entries(preq).forEach(([key, value]) => {
      if (value) {
        params = params.set(key, value);
      }
    });
    return this.http.get(`${NG_APP_API_ENDPOINT}/product/tire/to`, { params }).pipe(
      tap((res) => this.loggingService.log('TAP | getTireDecInc[ProductService] :', res)),
      map((res: any) => res.data),
      tap((res) => this.loggingService.log('TAP | getTireDecInc[ProductService] aftermap get data :', res)),
      catchError((error) => {
        this.loggingService.error('CATCH ERROR | getProductById[ProductService] :', error);
        return throwError(() => error);
      })
    );
  }

  // NOTE: GET DataSearchBlock
  getDataSearchBlock(
    category: string,
    input: ESearchBlockPath,
    visibility: string,
    options: ISearchBlockOptions = {}
  ): Observable<any> {
    let params = new HttpParams().set('visibility', visibility).set('category', category).set('input', input);

    // Add optional parameters dynamically
    Object.entries(options).forEach(([key, value]) => {
      if (value) {
        params = params.set(key, value);
      }
    });

    this.loggingService.warn('param naja :', params);
    return this.http.get(`${NG_APP_API_ENDPOINT}/product/option`, { params }).pipe(
      tap((res) => this.loggingService.warn('GET | getTireDecInc[API] :', res)),
      map((res: any) => res.data.rows),
      catchError((error) => {
        this.loggingService.error(error);
        return throwError(() => error);
      })
    );
  }
  //#endregion
  // !SECTION //

  // SECTION: BANNERS
  //#region
  // NOTE: GET AllBanners
  getAllBanner(visibility: string): Observable<IAllData> {
    return this.http.get<IApiResponseAll>(`${NG_APP_API_ENDPOINT}/content/banners?visibility=${visibility}`).pipe(
      tap((res) => this.loggingService.warn('GET | getAllBanner[API] :', res)),
      map((res: IApiResponseAll) => res.data as IAllData),
      catchError((error) => {
        this.loggingService.error(error);
        return throwError(() => error);
      })
    );
  }
  //#endregion
  // !SECTION //

  // SECTION: POPUPS
  //#region
  // NOTE: GET AllPopup
  getAllPopup(visibility: string): Observable<IAllData> {
    return this.http.get<IApiResponseAll>(`${NG_APP_API_ENDPOINT}/content/popups?visibility=${visibility}`).pipe(
      tap((res) => this.loggingService.warn('GET | getAllPopup[API] :', res)),
      map((res: IApiResponseAll) => res.data as IAllData),
      catchError((error) => {
        this.loggingService.error(error);
        return throwError(() => error);
      })
    );
  }
  //#endregion
  // !SECTION //

  // SECTION: PROMOTIONS
  //#region
  // NOTE: GET AllPromotion
  getAllPromotion(visibility: string, paging: IPaging = { cur: 1, per: 6 }): Observable<IAllData> {
    let params = new HttpParams().set('visibility', visibility);
    // Add paging parameters dynamically
    Object.entries(paging).forEach(([key, value]) => {
      if (value) {
        params = params.set(key, value);
      }
    });
    return this.http.get<IApiResponseAll>(`${NG_APP_API_ENDPOINT}/content/promotions`, { params }).pipe(
      tap((res) => this.loggingService.warn('GET | getAllPromotion[API] :', res)),
      map((res: IApiResponseAll) => res.data as IAllData),
      catchError((error) => {
        this.loggingService.error(error);
        return throwError(() => error);
      })
    );
  }
  // NOTE: GET Promotion
  getPromotionById(id: number): Observable<IPromotionData> {
    const idStr = id.toString();
    return this.http.get<IApiResponseData>(`${NG_APP_API_ENDPOINT}/content/promotion?id=${idStr}`).pipe(
      tap((res) => this.loggingService.warn('GET | getPromotionById[API] :', res)),
      map((res: IApiResponseData) => res.data as IPromotionData),
      catchError((error) => {
        this.loggingService.error(error);
        return throwError(() => error);
      })
    );
  }
  //#endregion
  // !SECTION //

  // SECTION: NEWS
  //#region
  // NOTE: GET AllNews
  getAllNews(visibility: string, paging: IPaging = { cur: 1, per: 9 }): Observable<IAllData> {
    let params = new HttpParams().set('visibility', visibility);

    // Add paging parameters dynamically
    Object.entries(paging).forEach(([key, value]) => {
      if (value) {
        params = params.set(key, value);
      }
    });

    return this.http.get<IApiResponseAll>(`${NG_APP_API_ENDPOINT}/content/newses`, { params }).pipe(
      tap((res) => this.loggingService.warn('GET | getAllNews[API] :', res)),
      map((res: IApiResponseAll) => res.data as IAllData),
      catchError((error) => {
        this.loggingService.error(error);
        return throwError(() => error);
      })
    );
  }
  // NOTE: GET NewsData
  getNewsById(id: number): Observable<INewsData> {
    const idStr = id.toString();
    return this.http.get<IApiResponseData>(`${NG_APP_API_ENDPOINT}/content/news?id=${idStr}`).pipe(
      tap((res) => this.loggingService.warn('GET | getNewsById[API] :', res)),
      map((res: IApiResponseData) => res.data as INewsData),
      catchError((error) => {
        this.loggingService.error(error);
        return throwError(() => error);
      })
    );
  }
  //#endregion
  // !SECTION //

  // SECTION: ARTICLE
  //#region
  // NOTE: GET AllArticle
  getAllArticle(visibility: string, paging: IPaging = { cur: 1, per: 9 }): Observable<IAllData> {
    let params = new HttpParams().set('visibility', visibility);

    // Add paging parameters dynamically
    Object.entries(paging).forEach(([key, value]) => {
      if (value) {
        params = params.set(key, value);
      }
    });

    return this.http.get<IApiResponseAll>(`${NG_APP_API_ENDPOINT}/content/articles`, { params }).pipe(
      tap((res) => this.loggingService.warn('GET | getAllArticle[API] :', res)),
      map((res: IApiResponseAll) => res.data as IAllData),
      catchError((error) => {
        this.loggingService.error(error);
        return throwError(() => error);
      })
    );
  }
  // NOTE: GET ArticleData
  getArticleById(id: number): Observable<INewsData> {
    const idStr = id.toString();
    return this.http.get<IApiResponseData>(`${NG_APP_API_ENDPOINT}/content/article?id=${idStr}`).pipe(
      tap((res) => this.loggingService.warn('GET | getArticleById[API] :', res)),
      map((res: IApiResponseData) => res.data as INewsData),
      catchError((error) => {
        this.loggingService.error(error);
        return throwError(() => error);
      })
    );
  }
  //#endregion
  // !SECTION //

  // SECTION: VIDEO
  //#region
  // NOTE: GET AllVideo
  getAllVideo(visibility: string, paging: IPaging = { cur: 1, per: 9 }): Observable<IAllData> {
    let params = new HttpParams().set('visibility', visibility);

    // Add paging parameters dynamically
    Object.entries(paging).forEach(([key, value]) => {
      if (value) {
        params = params.set(key, value);
      }
    });
    return this.http.get<IApiResponseAll>(`${NG_APP_API_ENDPOINT}/content/videos`, { params }).pipe(
      tap((res) => this.loggingService.warn('GET | getAllVideo[API] :', res)),
      map((res: IApiResponseAll) => res.data as IAllData),
      catchError((error) => {
        this.loggingService.error(error);
        return throwError(() => error);
      })
    );
  }
  // NOTE: GET VideoById
  getVideoById(id: number): Observable<IVideoData> {
    const idStr = id.toString();
    return this.http.get<IApiResponseData>(`${NG_APP_API_ENDPOINT}/content/video?id=${idStr}`).pipe(
      tap((res) => this.loggingService.warn('GET | getVideoById[API] :', res)),
      map((res: IApiResponseData) => res.data as IVideoData),
      catchError((error) => {
        this.loggingService.error(error);
        return throwError(() => error);
      })
    );
  }
  //#endregion
  // !SECTION //

  // SECTION: CENTER_SERVICE
  //#region
  // NOTE: GET AllCenter
  getAllCenter(): Observable<IApiResponseAll> {
    return this.http.get<IApiResponseAll>(`${NG_APP_API_ENDPOINT}/center-services?visibility=grip`).pipe(
      tap((res) => this.loggingService.warn('GET | getAllCenter[API] :', res))
      // map((res: IApiResponseAll) => {
      //   if (res.data.rows) {
      //     return res.data.rows;
      //   } else {
      //     return res.data;
      //   }
      // })
    );
  }
  //#endregion
  // !SECTION //

  // SECTION: BRANCH
  //#region
  // NOTE: GET AllBranch
  getAllBranch(
    visibility: string,
    options: IBranchSearchOptions = {},
    paging: IPaging = { cur: 1, per: 9 }
  ): Observable<IAllData> {
    let params = new HttpParams().set('visibility', visibility);
    // Add optional parameters dynamically
    Object.entries(options).forEach(([key, value]) => {
      if (value) {
        params = params.set(key, value);
      }
    });

    // Add paging parameters dynamically
    Object.entries(paging).forEach(([key, value]) => {
      if (value) {
        params = params.set(key, value);
      }
    });
    return this.http.get<IApiResponseAll>(`${NG_APP_API_ENDPOINT}/center-service/lists`, { params }).pipe(
      tap((res) => this.loggingService.warn('GET | getAllBranch[API] :', res)),
      map((res: IApiResponseAll) => res.data as IAllData),
      catchError((error) => {
        this.loggingService.error(error);
        return throwError(() => error);
      })
    );
  }

  // NOTE: GET BranchById
  getBranchById(visibility: string, id: number): Observable<IBranchDetails> {
    return this.http
      .get<IApiResponseData>(`${NG_APP_API_ENDPOINT}/center-service?visibility=${visibility}&id=${id}`)
      .pipe(
        tap((res) => this.loggingService.warn('GET | getBranchById[API] :', res)),
        map((res: IApiResponseData) => res.data as IBranchDetails),
        catchError((error) => {
          this.loggingService.error(error);
          return throwError(() => error);
        })
      );
  }

  // NOTE: GET BranchByName
  // getBranchByName(visibility: string, name: string): Observable<IAllData> {
  //   return this.http
  //     .get<IApiResponseAll>(`${BASE_URL}/center-service/search/name?visibility=${visibility}&name=${name}`)
  //     .pipe(
  //       tap((res) => this.loggingService.warn('GET | getBranchByName[API] :', res)),
  //       map((res: IApiResponseAll) => res.data as IAllData),
  //       catchError((error) => {
  //         this.loggingService.error(error);
  //         return throwError(() => error);
  //       })
  //     );
  // }
  getBranchByName(
    visibility: string,
    options: IBranchSearchOptions = {},
    paging: IPaging = { cur: 1, per: 9 }
  ): Observable<IAllData> {
    let params = new HttpParams().set('visibility', visibility);

    // Add optional parameters dynamically
    Object.entries(options).forEach(([key, value]) => {
      if (value) {
        params = params.set(key, value);
      }
    });

    Object.entries(paging).forEach(([key, value]) => {
      if (value) {
        params = params.set(key, value);
      }
    });
    return this.http.get<IApiResponseAll>(`${NG_APP_API_ENDPOINT}/center-service/lists`, { params }).pipe(
      tap((res) => this.loggingService.warn('GET | getBranchByName[API] :', res.data)),
      map((res: IApiResponseAll) => res.data as IAllData),
      catchError((error) => {
        this.loggingService.error(error);
        return throwError(() => error);
      })
    );
  }

  // NOTE: GET BranchByCurrentLocation
  getBranchByCurrentLocation(visibility: string, lat: number, lng: number): Observable<IAllData> {
    return this.http
      .get<IApiResponseAll>(
        `${NG_APP_API_ENDPOINT}/center-service/search/location?visibility=${visibility}&lat=${lat}&lng=${lng}`
      )
      .pipe(
        tap((res) => this.loggingService.warn('GET | getBranchByCurrentLocation[API] :', res)),
        map((res: IApiResponseAll) => res.data as IAllData),
        catchError((error) => {
          this.loggingService.error(error);
          return throwError(() => error);
        })
      );
  }
  //#endregion
  // !SECTION //
  // !SECTION //

  ////////////////////////////////////////////

  // SECTION: POST

  // SECTION: CONTACT
  // NOTE: POST Contact
  postContact(body: IApiRequestContactBody) {
    return this.http
      .post(`${NG_APP_API_ENDPOINT}/contact/save`, body)
      .pipe(tap((res) => this.loggingService.warn('POST | postContact [API] :', res)));
  }

  // NOTE: POST Gallery Like
  postGalleryLike(
    galleryId: number,
    ipAddress: string
  ): Observable<{ success: boolean; like_count: number; like_status: number }> {
    const body = { gallery_id: galleryId, ip_address: ipAddress };
    return this.http
      .post<{ success: boolean; like_count: number; like_status: number }>(
        `${NG_APP_API_ENDPOINT}/gallery/like?gallery_id=${galleryId}&ip_address=${ipAddress}`,
        body
      )
      .pipe(
        tap((res) => this.loggingService.warn('POST | postGalleryLike [API] :', res)),
        catchError((error) => {
          this.loggingService.error('Error in postGalleryLike:', error);
          return throwError(() => error);
        })
      );
  }
  // !SECTION //

  //NOTE - POST: Gallery like V2
  postGalleryLikeV2(body: IApiRequestGalleryLikeBody) {
    return this.http
      .post(`${NG_APP_API_ENDPOINT}/gallery/like`, body)
      .pipe(tap((res) => this.loggingService.warn('POST | postGalleryLikeV2 [API] :', res)));
  }
  // !SECTION //

  getMenuProduct(visibility: string) {
    return this.http.get<IApiResponseAll>(`${NG_APP_API_ENDPOINT}/product/categories?visibility=${visibility}`).pipe(
      tap((res) => this.loggingService.warn('GET | getMenuProduct[API] :', res)),
      map((res: IApiResponseAll) => res.data as IAllData),
      catchError((error) => {
        this.loggingService.error(error);
        return throwError(() => error);
      })
    );
  }
  getSubMenuTire(visibility: string, brand?: string) {
    // let tire_brand = 0;
    // switch (visibility) {
    //   case 'toyo':
    //     tire_brand = 1; //id brand
    //     break;
    //   case 'nitto':
    //     tire_brand = 2;
    //     break;
    //   case 'nankang':
    //     tire_brand = 4;
    //     break;
    //   default:
    //     break;
    // }
    // this.loggingService.warn('tire_brand', visibility);
    // this.loggingService.warn('tire_brand', tire_brand);

    if (visibility === 'grip') {
      return this.http
        .get<IApiResponseAll>(`${NG_APP_API_ENDPOINT}/product/tire/models?visibility=${visibility}&tire_brand=${brand}`)
        .pipe(
          tap((res) => this.loggingService.warn('GET | getSubMenuTire[API] :', res)),
          map((res: IApiResponseAll) => res.data as IAllData),
          catchError((error) => {
            this.loggingService.error(error);
            return throwError(() => error);
          })
        );
    } else {
      return this.http.get<IApiResponseAll>(`${NG_APP_API_ENDPOINT}/product/tire/models?visibility=${visibility}`).pipe(
        tap((res) => this.loggingService.warn('GET | getSubMenuTire[API] :', res)),
        map((res: IApiResponseAll) => res.data as IAllData),
        catchError((error) => {
          this.loggingService.error(error);
          return throwError(() => error);
        })
      );
    }
  }
  getSubMenuIDTire(visibility: string, name: string, brand?: any) {
    this.loggingService.warn('GET | getSubMenuIDTire[API] :', name);
    this.loggingService.warn('GET | getSubMenuIDTire[API] :', brand);
    // let tire_brand = 0;
    // switch (visibility) {
    // case 'toyo':
    //   tire_brand = 1;
    //   break;
    // case 'nitto':
    //   tire_brand = 2;
    //   break;
    // case 'nankang':
    //   tire_brand = 4;
    //   break;
    //   case 'grip':
    //     tire_brand = brand;
    //     break;

    //   default:
    //     break;
    // }
    const encodedName = encodeURIComponent(name);
    if (visibility == 'grip') {
      return this.http
        .get<IApiResponseAll>(
          `${NG_APP_API_ENDPOINT}/product/tire/model-first-id?visibility=${visibility}&brand=${brand}&model=${encodedName}`
        )
        .pipe(
          tap((res) => this.loggingService.warn('GET | getMenuProduct[API] :', res)),
          map((res: IApiResponseAll) => res.data as IAllData),
          catchError((error) => {
            this.loggingService.error(error);
            return throwError(() => error);
          })
        );
    } else {
      return this.http
        .get<IApiResponseAll>(
          `${NG_APP_API_ENDPOINT}/product/tire/model-first-id?visibility=${visibility}&model=${encodedName}`
        )
        .pipe(
          tap((res) => this.loggingService.warn('GET | getMenuProduct[API] :', res)),
          map((res: IApiResponseAll) => res.data as IAllData),
          catchError((error) => {
            this.loggingService.error(error);
            return throwError(() => error);
          })
        );
    }
  }

  getSubMenuBrandTire(visibility: string) {
    return this.http
      .get<IApiResponseAll>(`${NG_APP_API_ENDPOINT}/product/brands?visibility=${visibility}&category=1`)
      .pipe(
        tap((res) => this.loggingService.warn('GET | getMenuProduct[API] :', res)),
        map((res: IApiResponseAll) => res.data as IAllData),
        catchError((error) => {
          this.loggingService.error(error);
          return throwError(() => error);
        })
      );
  }
  getSubMenuModelTire(visibility: string, category: string, input: string, options: IProductSearchOptions) {
    let params = new HttpParams().set('visibility', visibility).set('category', category).set('input', input);
    Object.entries(options).forEach(([key, value]) => {
      if (value) {
        params = params.set(key, value);
      }
    });

    return this.http.get(`${NG_APP_API_ENDPOINT}/product/option`, { params }).pipe(
      tap((res) => this.loggingService.warn('GET | getSubMenuModelTire[API] :', res)),
      map((res: any) => res.data),
      catchError((error) => {
        this.loggingService.error(error);
        return throwError(() => error);
      })
    );
  }

  getHighlightsFilter(visibility: string) {
    return this.http
      .get<IApiResponseAll>(`${NG_APP_API_ENDPOINT}/product/tire/highlights?visibility=${visibility}`)
      .pipe(
        tap((res) => this.loggingService.warn('GET | getHighlights[API] :', res)),
        map((res: IApiResponseAll) => res.data as IAllData),
        catchError((error) => {
          this.loggingService.error(error);
          return throwError(() => error);
        })
      );
  }
  getTypesFilter(visibility: string) {
    return this.http.get<IApiResponseAll>(`${NG_APP_API_ENDPOINT}/product/tire/types?visibility=${visibility}`).pipe(
      tap((res) => this.loggingService.warn('GET | getHighlights[API] :', res)),
      map((res: IApiResponseAll) => res.data as IAllData),

      catchError((error) => {
        this.loggingService.error(error);
        return throwError(() => error);
      })
    );
  }

  //NOTE - GetAllGallery
  getAllGallery(visibility: string, options?: IOption, sort_hot_badge?: number): Observable<IAllData> {
    // const sortStr = sort_hot_badge?.toString();
    let params = new HttpParams().set('visibility', visibility);

    const { paging, car_id, car_model_id, tire_brand_id, tire_model_name } = options || {};

    const defaultPaging: IPaging = paging || { cur: 1, per: 9 };
    // Add paging parameters dynamically
    Object.entries(defaultPaging).forEach(([key, value]) => {
      if (value) {
        params = params.set(key, value);
      }
    });

    // Add optional parameters if they exist
    if (car_id) {
      params = params.set('car_id', car_id);
    }
    if (car_model_id) {
      params = params.set('car_model_id', car_model_id);
    }
    if (tire_brand_id) {
      params = params.set('tire_brand_id', tire_brand_id);
    }
    if (tire_model_name) {
      params = params.set('tire_model_name', tire_model_name);
    }

    return this.http
      .get<IApiResponseAll>(
        `${NG_APP_API_ENDPOINT}/gallery/lists?visibility=${visibility}&sort_hot_badge=${sort_hot_badge}`,
        {
          params,
        }
      )
      .pipe(
        tap((res) => this.loggingService.warn('GET | getAllGallery[API] :', res)),
        map((res: IApiResponseAll) => res.data as IAllData),
        catchError((error) => {
          this.loggingService.error(error);
          return throwError(() => error);
        })
      );
  }
  getGalleryById(id: number, ip: string): Observable<IGalleryData> {
    const idStr = id.toString();
    return this.http.get<IApiResponseData>(`${NG_APP_API_ENDPOINT}/gallery/data?id=${idStr}&ip_address=${ip}`).pipe(
      tap((res) => this.loggingService.warn('GET | getGalleryById[API] :', res)),
      map((res: IApiResponseData) => res.data as IGalleryData),
      catchError((error) => {
        this.loggingService.error(error);
        return throwError(() => error);
      })
    );
  }

  getGalleryCarOptions() {
    return this.http.get<IApiResponseAll>(`${NG_APP_API_ENDPOINT}/gallery/car/options`).pipe(
      tap((res) => this.loggingService.warn('GET | getGalleryCarOptions[API] :', res)),
      map((res: IApiResponseAll) => res.data as IAllData),
      catchError((error) => {
        this.loggingService.error(error);
        return throwError(() => error);
      })
    );
  }

  getGalleryCarModelOptions(id: number) {
    return this.http.get<IApiResponseAll>(`${NG_APP_API_ENDPOINT}/gallery/car-model/options?car_id=${id}`).pipe(
      tap((res) => this.loggingService.warn('GET | getGalleryCarModelOptions[API] :', res)),
      map((res: IApiResponseAll) => res.data as IAllData),
      catchError((error) => {
        this.loggingService.error(error);
        return throwError(() => error);
      })
    );
  }
  getGalleryTireModelOptions(visibility: string, id?: number) {
    return this.http
      .get<IApiResponseAll>(
        `${NG_APP_API_ENDPOINT}/gallery/tire-model/options?visibility=${visibility}&tire_brand_id=${id}`
      )
      .pipe(
        tap((res) => this.loggingService.warn('GET | getGalleryTireModelOptions[API] :', res)),
        map((res: IApiResponseAll) => res.data as IAllData),
        catchError((error) => {
          this.loggingService.error(error);
          return throwError(() => error);
        })
      );
  }
  getGalleryTireBrandOptions() {
    return this.http.get<IApiResponseAll>(`${NG_APP_API_ENDPOINT}/gallery/tire-brand/options`).pipe(
      tap((res) => this.loggingService.warn('GET | getGalleryTireBrandOptions[API] :', res)),
      map((res: IApiResponseAll) => res.data as IAllData),
      catchError((error) => {
        this.loggingService.error(error);
        return throwError(() => error);
      })
    );
  }
}
